import { TemplatePage } from './types';

const adsPromoAdsPage: TemplatePage = {
  header: {
    color: '#EBA4A8',
    icon: 'images/video-templates/ads-promo.jpg',
    title: 'Video Ad Templates Collection',
    title_meta: '200+ Free and Customizable Video Ad Templates',
    description_meta:
      'Create attention-grabbing advertising videos easily with Wave.video’s collection of 200+ customizable ' +
      'free video ad templates.',
    description:
      'Want to create attention-grabbing advertising videos without spending a fortune on production? Then this ' +
      'collection of 200+ customizable video ad templates is exactly what you need!'
  },
  footer: {
    category: 'ads',
    description:
      'Wave.video’s extensive collection of ready-to-edit video ad templates helps create engaging and beautiful ' +
      'videos in minutes. All the templates are free and easy to personalize to suit your brand and topic.'
  },
  content: [
    {
      type: 'templates',
      title: 'Video Ad Templates',
      search: { category: '/Use Cases/Ads' }
    },
    {
      type: 'stocks',
      title: 'ads',
      search: { name: 'ads' }
    },
    { type: 'calendar' }
  ]
};

export default adsPromoAdsPage;
